import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { makeStyles, Paper, Tab, Tabs } from '@material-ui/core';
import clsx from 'clsx';
import { NavLink, useLocation } from 'react-router-dom';
import { appHeaderHeight, pxToRem, topNavHeight, transitionSpeed } from '../../theme';
const useStyles = makeStyles((theme) => ({
    root: {
        alignItems: 'center',
        backgroundColor: theme.palette.brand.feather25,
        borderBottom: `1px solid ${theme.palette.divider}`,
        display: 'flex',
        justifyContent: 'space-between',
        padding: theme.spacing(0, 2),
        position: 'sticky',
        top: appHeaderHeight,
        width: '100%',
        zIndex: 5,
    },
    rightComponent: {
        marginLeft: theme.spacing(2),
    },
    tabContainer: {
        alignItems: 'center',
        padding: 0,
        '& .MuiTabs-scrollButtonsDesktop': {
            display: 'flex',
        },
    },
    tab: {
        background: 'none',
        border: 0,
        borderBottom: '3px solid transparent',
        color: theme.palette.text.primary,
        fontSize: pxToRem(14),
        fontWeight: 400,
        height: `calc(${topNavHeight}px - 1px)`,
        lineHeight: pxToRem(21),
        minWidth: 0,
        opacity: 1,
        padding: theme.spacing(0, 2),
        textDecoration: 'none',
        textTransform: 'capitalize',
        transition: `${transitionSpeed}`,
        width: 'auto',
        '&.active, &.compared': {
            borderColor: theme.palette.primary.main,
            fontWeight: 600,
        },
    },
}));
/**
 * Top navigational component
 *
 * @param links - An array of links to be displayed in the top navigation.
 * @returns The rendered `TopNav` component.
 */
export function TopNav({ componentRight, links }) {
    const classes = useStyles();
    const location = useLocation();
    // Temp fix to allow ANS to work
    // ANS has a Router issue and set state manually
    // This should be removed once that is updated for `NavLink` which will do this automatically
    const hasPartialMatch = (str1, str2) => {
        const parts1 = str1.split('/').filter((part) => part !== '');
        const parts2 = str2.split('/').filter((part) => part !== '');
        if (parts1[0] === parts2[0])
            return true;
        return false;
    };
    return (_jsxs(Paper, { className: classes.root, elevation: 0, square: true, children: [_jsx(Tabs, { className: classes.tabContainer, indicatorColor: 'primary', scrollButtons: 'auto', value: false, variant: 'scrollable', children: links.map(({ testId, text, url }) => (_jsx(Tab, { className: clsx(classes.tab, {
                        ['compared']: hasPartialMatch(location.pathname, url),
                    }), component: NavLink, "data-testid": testId, disableRipple: true, label: text, tabIndex: 0, to: url }, text))) }), _jsx("div", { className: classes.rightComponent, children: componentRight })] }));
}
